import { render, staticRenderFns } from "./payError.vue?vue&type=template&id=0face1ea&scoped=true&"
import script from "./payError.vue?vue&type=script&lang=js&"
export * from "./payError.vue?vue&type=script&lang=js&"
import style0 from "./payError.vue?vue&type=style&index=0&id=0face1ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0face1ea",
  null
  
)

export default component.exports